import * as IconSelector from '../icons';

export const sistemasExplotacion = [
    {
        value: null,
        label: 'Sin definir',
        description: 'Sin sistema definido',
        icon: IconSelector.PointIcon,
        color: 'Black'
    },
    {
        value: 'Propiedad',
        label: 'Propiedad',
        description: 'Propiedad',
        icon: IconSelector.PointIcon,
        color: 'Blue'
    },
    {
        value: 'Arrendamiento',
        label: 'Arrendamiento',
        description: 'Arrendamiento',
        icon: IconSelector.PointIcon,
        color: 'Green'
    },
    {
        value: 'Aparceria',
        label: 'Aparcería',
        description: 'Aparceria',
        icon: IconSelector.PointIcon,
        color: 'Orange'
    }
];
